import {
  app,
  Component,
  ojs,
  each,
  state,
  v,
  component,
} from "modular-openscriptjs";
import {
  pageInfo,
  scrollToTop,
} from "../../../helpers";
import { api, dc } from "../../../declarations";
import CompactProductCard from "../../Views/CompactProductCard";
import SolidIcon from "../../Blocks/SolidIcon";
import Spinner from "../../Blocks/Spinner";

const h = app("h");
const router = app("router");

ojs(CompactProductCard, SolidIcon, Spinner);

export default class SubCategoriesPage extends Component {
  subcategories = state([]);
  category = state(null);
  loading = state(true);
  businessId = null;
  categoryId = null;

  render(...args) {
    this.businessId = router.params.companyId;
    this.categoryId = router.params.categoryId;
    
    pageInfo("Subcategories");
    scrollToTop();

    if (this.loading.value && this.subcategories.value.length === 0) {
        this.fetchSubcategories();
    }

    return h.div(
      { class: "py-4 mx-auto w-100 container mb-5 py-md-5" },
      
      h.div(
          { class: "mb-4 d-flex align-items-center gap-3" },
          h.button(
              { class: "btn btn-white border shadow-sm rounded-circle p-2", onclick: "history.back()" },
              h.SolidIcon("arrow-left")
          ),
          v(this.category, (cat) => h.h2({ class: "fw-bold mb-0" }, cat.value?.name || "Subcategories"))
      ),

      v(this.loading, (l) => {
          if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

          return v(this.subcategories, (subs) => {
              if (subs.value.length === 0) {
                  return h.div({ class: "text-center py-5 text-muted" }, "No subcategories found for this category.");
              }

              return h.div(
                  { class: "gap-5" },
                  ...subs.value.map(sub => this.renderSubcategoryRow(sub))
              );
          });
      }),
      ...args
    );
  }

  renderSubcategoryRow(sub) {
      return h.div(
          { class: "subcategory-row" },
          h.div(
              { class: "d-flex justify-content-between align-items-center mb-3 px-1" },
              h.h5({ class: "fw-bold mb-0" }, sub.name),
              h.button(
                  { 
                      class: "btn btn-link text-primary text-decoration-none fw-bold p-0",
                      listeners: {
                        click: () => router.to("business.inventory.subcategory.browse", { 
                          companyId: this.businessId,
                          subcategoryId: sub.id 
                      })
                      }
                  },
                  "View All",
                  h.i({ class: "bi bi-chevron-right ms-1" })
              )
          ),
          h.div(
              { class: "d-flex gap-3 overflow-x-auto pb-3 desktop-scrollbar" },
              ...sub.products.map(product => h.CompactProductCard(product))
          )
      );
  }

  async fetchSubcategories() {
      try {
          const res = await api.get(`companies/${this.businessId}/categories/${this.categoryId}/subcategories-with-products`);
          if (res) {
              this.subcategories.value = res.data.subcategories;
              this.category.value = res.data.category;
              if (res.data.category) {
                  pageInfo(`${res.data.category.name} - Inventory`);
              }
          }
      } catch (e) {
          console.error(e);
      } finally {
          this.loading.value = false;
      }
  }
}

ojs(SubCategoriesPage);
